import React, { useState } from 'react';
import { Shield, LogIn } from 'lucide-react';
import { issuesApi } from '../../services/issuesApi';
import '../issues/Issues.css';

export default function AdminLogin({ onLogin, onNavigate }) {
  const [email, setEmail] = useState('');
  
  // Navigation helper
  const navigate = (path) => {
    if (onNavigate) {
      if (path === '/admin/issues') {
        onNavigate('issues-admin');
      } else if (path === '/issues') {
        onNavigate('issues');
      }
    }
  };
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!email || !password) {
      setError('Please enter both email and password');
      return;
    }
    
    try {
      setLoading(true);
      const result = await issuesApi.adminLogin(email, password);
      
      // Store token
      localStorage.setItem('adminToken', result.token);
      localStorage.setItem('adminEmail', result.email);
      
      if (onLogin) {
        onLogin(result);
      }
      
      navigate('/admin/issues');
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.error || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <Shield size={48} style={{ color: '#D4AF37', marginBottom: '1rem' }} />
          <h1>Admin Login</h1>
          <p>Issue Tracking System</p>
        </div>
        
        <form className="admin-login-form" onSubmit={handleSubmit}>
          {error && (
            <div className="admin-login-error">
              {error}
            </div>
          )}
          
          <input
            type="email"
            className="admin-login-input"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
          
          <input
            type="password"
            className="admin-login-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          
          <button 
            type="submit" 
            className="admin-login-btn"
            disabled={loading}
          >
            {loading ? 'Signing in...' : (
              <>
                <LogIn size={18} style={{ marginRight: '0.5rem' }} />
                Sign In
              </>
            )}
          </button>
        </form>
        
        <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
          <button 
            onClick={() => navigate('/issues')}
            style={{ 
              background: 'none', 
              border: 'none', 
              color: '#666', 
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            Back to Public Issues
          </button>
        </div>
      </div>
    </div>
  );
}

